import React from 'react';

export default class extends React.PureComponent {

    render () {
        var id = "switch" + Math.trunc(Math.random() * 100000);
        var className = "switch-lg";
        if (this.props.smallFormat) {
            className = "switch-small";
        }
        return (
            <label className={className}> {/* https://www.w3schools.com/howto/howto_css_switch.asp. Not using boostrap 4 custom-switch b/c it is not trivial to resize (https://getbootstrap.com/docs/4.2/components/forms/#switches / https://stackoverflow.com/questions/55593229/increasing-the-size-of-a-bootstrap-checkbox) */}
                <input
                    type="checkbox"
                    className="switch-checkbox"
                    checked={this.props.checked}
                    id={id}
                    onChange={this.props.onChange}
                    disabled={this.props.disabled}
                />
                <span className="switch-slider round"></span>
            </label>
        )    
    }
};
